function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2998 3.54506C6.5701 3.54506 3.54506 6.57224 3.54506 10.3083C3.54506 14.0443 6.5701 17.0715 10.2998 17.0715C11.9739 17.0715 13.5041 16.4627 14.6845 15.4531C16.1361 14.2116 17.0546 12.3678 17.0546 10.3083C17.0546 6.57224 14.0296 3.54506 10.2998 3.54506ZM2 10.3083C2 5.72056 5.71515 2 10.2998 2C14.8845 2 18.5997 5.72056 18.5997 10.3083C18.5997 12.5382 17.7213 14.5635 16.2937 16.0552L20.9156 20.6815C21.2172 20.9833 21.2169 21.4724 20.9151 21.774C20.6133 22.0755 20.1241 22.0753 19.8226 21.7735L15.1236 17.0701C13.7642 18.0433 12.0982 18.6166 10.2998 18.6166C5.71515 18.6166 2 14.896 2 10.3083Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.76534 5.6864C9.91009 6.08776 9.70207 6.53046 9.30072 6.67521C8.19682 7.07334 6.90842 8.24307 6.71545 9.83949C6.66425 10.2631 6.27936 10.5649 5.85579 10.5137C5.43222 10.4625 5.13035 10.0776 5.18155 9.65407C5.46068 7.34491 7.2624 5.76786 8.77653 5.22178C9.17789 5.07703 9.62059 5.28505 9.76534 5.6864Z",
  fill: "#738BA5"
});

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.08341686.svg";
export { ForwardRef as ReactComponent };